import React from 'react'
import {TabHeader, ActivityFeed} from '@/ui/index'
import {Tab} from '@/types/components'

export function OrgActivity({title, description}: Tab) {
  return <ActivityFeed header={<TabHeader title={title} description={description} />} />
}
